import type { Region } from './index'

// Canonical sort order for US regions (50 states + DC). Alphabetical by
// 2-letter USPS code — matches historic ordering used across all
// dictionary tables that partition by region. Explicit `<`/`>` avoids the
// locale-sensitivity of `String.prototype.localeCompare`; for ASCII
// 2-letter codes the result is identical, but the comparator is stable
// across environments.
export const compareRegions = (a: Region, b: Region): number =>
  a < b ? -1 : a > b ? 1 : 0
